import {CanActivateFn} from '@angular/router';
import {inject} from '@angular/core';
import {ResetPasswordEnforcementService} from '../services/reset-password-enforcement.service';
import {TokenService} from '../services/token.service';
import {RouterService} from '../services/router.service';

const PASSWORD_CHANGE_ROUTE: string = '/auth/password/change';

export const passwordChangeEnforcementGuard: CanActivateFn = (_route, state) => {
  const resetPasswordEnforcementService = inject(ResetPasswordEnforcementService);
  const tokenService = inject(TokenService);
  const routerService = inject(RouterService);

  const requestedPath = state.url.split('?')[0];
  const isPasswordChangeRoute = requestedPath === PASSWORD_CHANGE_ROUTE;
  const isLoggedIn = tokenService.hasToken();
  const hasRequirement = resetPasswordEnforcementService.hasPasswordChangeRequirement();

  if (hasRequirement) {
    if (!isLoggedIn) {
      resetPasswordEnforcementService.clearAllPasswordChangeContext();
      if (isPasswordChangeRoute) {
        routerService.navigateTo('/auth/login');
        return false;
      }
      return true;
    }

    if (!isPasswordChangeRoute) {
      routerService.navigateTo(PASSWORD_CHANGE_ROUTE);
      return false;
    }

    return true;
  }

  if (isPasswordChangeRoute) {
    if (isLoggedIn) {
      routerService.navigateToStart();
    } else {
      routerService.navigateTo('/auth/login');
    }
    return false;
  }

  return true;
};

